export enum PAYMENT_STATUS {
    PAID = 'paid',
    UNPAID = 'unpaid',
    IN_PAYMENT = 'in_payment',
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
    PENDING = 'PENDING'
}
